import React from 'react';
import { Link as SPALink } from '@atlassian/react-resource-router/src/Link.tsx';
import { defineMessages } from '@atlassian/jira-intl';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';

const messages = defineMessages({
	issueCount: {
		id: 'project-components.table-issues-cell-content',
		defaultMessage: '{number} {number, plural, one {issue} other {issues}}',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	ariaLabel: {
		id: 'project-components.table-issues-cell-content-aria-label',
		defaultMessage: '{number} {number, plural, one {issue} other {issues}} for {name}',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});

export type Props = {
	issuesUrl: string;
	number: number;
	name: string;
};

type PropsWithIntl = Props & {
	intl: IntlShape;
};

function IssuesView(props: PropsWithIntl) {
	const {
		number,
		issuesUrl,
		name,
		intl: { formatMessage },
	} = props;
	const content = formatMessage(messages.issueCount, { number: number.toString() });
	const ariaLabel = formatMessage(messages.ariaLabel, { number: number.toString(), name });
	return (
		<SPALink href={issuesUrl} aria-label={ariaLabel}>
			{content}
		</SPALink>
	);
}

export default injectIntl(IssuesView);
